// Chatling (Pinky) chat widget injection.
// Design spec: docs/superpowers/specs/2026-07-13-chatling-and-tour-design.md
// - Env-gated: no VITE_CHATLING_ID -> no script, silently.
// - NO hardcoded fallback bot ID, and chtlConfig must never carry
//   user data (`variables`) — compliance constraints, not defaults.

declare global {
  interface Window {
    chtlConfig?: { chatbotId: string };
  }
}

const SCRIPT_ID = "chtl-script";
const EMBED_SRC = "https://chatling.ai/js/embed.js";

export function normalizeChatlingId(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const id = raw.trim();
  // Jenkins/Vite can stringify unset vars into these literals.
  if (!id || id === "undefined" || id === "null" || id === "false") return null;
  return id;
}

/**
 * Idempotently inject the Chatling embed script. Returns true when the
 * widget is (or already was) set up, false when disabled by config.
 */
export function initChatling(): boolean {
  const id = normalizeChatlingId(import.meta.env.VITE_CHATLING_ID);
  if (!id) return false;
  if (window.chtlConfig || document.getElementById(SCRIPT_ID)) return true;

  window.chtlConfig = { chatbotId: id };

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.src = EMBED_SRC;
  script.async = true;
  script.setAttribute("data-id", id);
  document.body.appendChild(script);
  // No cleanup: Chatling owns its DOM from here (mounted once, outside
  // any v-if region, so Vue re-renders never touch it).
  return true;
}
